import React from 'react'
import { AddExclusionFlowProvider } from './context/AddExclusionFlowProvider'
import { AddExclusionFlowMain } from './components/AddExclusionFlowMain'
import { useRuleDetailContextValue } from '../../context/RuleDetailProvider'

export const AddExclusionFlow = () => {
  const {
    state: { id: ruleId },
  } = useRuleDetailContextValue()

  return (
    <AddExclusionFlowProvider ruleId={ruleId}>
      <AddExclusionFlowMain />
    </AddExclusionFlowProvider>
  )
}
